import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    Grid, TextField, FormControl, InputLabel, Select, MenuItem,
    CircularProgress, Box, Typography, CardContent, CardActions, Card
} from '@mui/material';
import ModalRealatorioDeVendas from '../../components/ModalRelatorioDeVendas';
import { useRelatoriosStore } from '../../store/RelatoriosStore';

export default function RelatoriosPage() {
    const { BuscarRelatorioDeVendas, loading } = useRelatoriosStore();

    const [modalRelatorioDeVendas, setmodalRelatorioDeVendas] = useState(false);

    const AbriModalRelatorioDeVendas = () => {
        setmodalRelatorioDeVendas(true)
    }

    const FecharModalRelatorioDeVendas = () => {
        setmodalRelatorioDeVendas(false)
    }

    const HandleVendas = (dados_dos_fitros) => {
        BuscarRelatorioDeVendas(dados_dos_fitros);
        // FecharModalRelatorioDeVendas();
    }


    return (
        <Box>
            <DialogContent>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                        <Card sx={{ minWidth: 200 }} onClick={() => { AbriModalRelatorioDeVendas() }} >
                            <CardContent>
                                <Typography textAlign='center' variant="h5" component="div">
                                    Vendas
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                        <Card sx={{ minWidth: 200 }}>
                            <CardContent>
                                <Typography textAlign='center' variant="h5" component="div">
                                    Produtos
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                        <Card sx={{ minWidth: 200 }}>
                            <CardContent>
                                <Typography textAlign='center' variant="h5" component="div">
                                    Maquinas
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </DialogContent>


            {/* MODAL DE RELATÓRIO DE VENDAS */}
            <ModalRealatorioDeVendas
                open={modalRelatorioDeVendas}
                onClose={FecharModalRelatorioDeVendas}
                isLoading={loading}
                onSearch={HandleVendas}
            />

        </Box>
    )
}